import type { Metadata } from "next";
import { NameAnalysisTool } from "@/components/name-analysis-tool";

export const metadata: Metadata = {
  title: "Đặt Tên Con — Tử Vi Số",
  description: "Phân tích tên con theo Thần Số Học, Mệnh ngũ hành và âm điệu.",
};

type Props = { searchParams: Promise<{ name?: string; date?: string }> };

export default async function NamingChildPage({ searchParams }: Props) {
  const sp = await searchParams;
  return (
    <NameAnalysisTool
      searchParams={sp}
      title="Đặt Tên Con"
      hint="Phân tích tên dự kiến theo Mệnh, Số chủ đạo và âm điệu."
      mode="person"
    />
  );
}
